var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monaco-editor"},[_c('div',{ref:"container",staticClass:"monaco-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }